import axios from "axios";

export default class ClubController {
    static async destroy(clubId: string | number) {
        const result = await axios.delete<void>(`/api/club/customer/clubs/${clubId}`)
        return result.data
    }
}